export default
  {
    components: {},
    props: {},
    data() {
      return {
        parm: {
          size: 10,
          total: 0,
          current: 1,
        },
        list: [],
        listLoading: false,
        cellMouseData: null,
        //  如果不想自动请求  改这个
        autoGetList:true
      }
    },
    computed: {},
    watch: {},
    created() { },
    mounted() {
      this.autoGetList && this.getList();
    },
    destroyed() { },
    methods: {
      sizeChange(size) {
        this.changeParm({ size })
        this.getList();
      },
      currentChange(current) {
        this.changeParm({ current })
        this.getList();
      },
      onSearch() {
        this.changeParm({ current: 1 })
        this.getList();
      },
      changeParm(data) {
        this.parm = {
          ...this.parm,
          ...data,
        };
      },
      getListCallback() { },
      async getList() {
        try {
          this.listLoading = true;
          const { total, ...parm } = this.parm
          const res = await this.listApi(parm);
          this.getListCallback(res);
          const { data, status } = res
          if (status === 200) {
            this.list = data.records;
            this.changeParm({
              size: data.size,
              total: data.total,
              current: data.current,
            });
          }
        } finally {
          this.listLoading = false
        }
      },
      cellMouseEnter(row) {
        this.cellMouseData = row;
      },
      cellMouseLeave() {
        this.cellMouseData = null;
      },
    }
  };